/** @jsx jsx */
import { jsx } from '@emotion/react';
import React, { useContext } from 'react';
import { WorkspaceContext } from '/views/workspace/workspaceContext';
import { WorkspaceActionCreator } from 'hooks/useWorkspaceState';
import {CommonDropdownWithLabel} from '../dropdowns/common-dropdown-with-label';

/**
 * Allows for the selection of a parameter with the given property name chosen from the given set of values
 *
 * @param cardIndex
 * @param propertyName
 * @param label
 * @param values
 * @param defaultValue
 * @param endpointQuery
 * @param optionToString
 * @param optionToValue
 * @param rest
 * @returns {JSX.Element}
 * @constructor
 */
export const EndpointParameterSelector = ({
	cardIndex,
	propertyName,
	values,
	defaultValue,
	endpointQuery,
	optionToString = (item) => item?.label,
	optionToValue = (item) => item?.value,
	...rest
}) => {
	const { dispatch } = useContext(WorkspaceContext);

	const handleSelectionChange = (newVal) => {
		const configuration = JSON.parse(JSON.stringify(endpointQuery));
		if (newVal === null || optionToValue(newVal) === 'default' || optionToValue(newVal) === 'none') {
			delete configuration.options.parameters[propertyName];
		} else {
			configuration.options.parameters[propertyName] = optionToValue(newVal);
		}
		dispatch(WorkspaceActionCreator.options(cardIndex, configuration));
	};

	const activeName = endpointQuery?.options?.parameters?.[propertyName];
	const activeItem = activeName ? values.find((item) => optionToValue(item) === activeName) : defaultValue;


	return (
		<CommonDropdownWithLabel
			options={values}
			onSelectionChanged={handleSelectionChange}
			activeItem={activeItem}
			optionToString={optionToString}

			btnText={optionToString(activeItem)}
			{...rest}
		/>
	);
};
